import React, { useEffect, useRef, useState } from "react";
import { FaCheck, FaFacebook } from "react-icons/fa";
import { FaRegFaceSmile, FaSquareInstagram } from "react-icons/fa6";
import {
  editPost,
  getActivityLog,
  postActivity,
} from "../../redux/slices/apiSlice";
import { useDispatch, useSelector } from "react-redux";
import { IoIosAt } from "react-icons/io";
import userImage from "../../assets/images/user.jpg";
import {
  RxCaretDown,
  RxCaretUp,
  RxCrossCircled,
  RxPaperPlane,
} from "react-icons/rx";
import post_icon from "../../assets/icons/post_icon.png";
import Loader from "../../utils/Loader";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { ImCross } from "react-icons/im";
import { showAlert } from "../../utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import SocialDialog from "./SocialDialog";

const PostPreview = ({ postContent, showApproval, close }) => {
  const [postAction, setPostAction] = useState(false);
  const [reviewType, setReviewType] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [viewApproveBtn, setViewApproveBtn] = useState(true);
  const [schedule, setSchedule] = useState(false);
  const [reviewValue, setReviewValue] = useState("Yet to Review");
  const [comment, setComment] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectDialog, setRejectDialog] = useState(false);
  const menuRef = useRef(null);
  const menuRef2 = useRef(null);

  const dispatch = useDispatch();
  const { recentActivity, isEditPostLoading } = useSelector(
    (state) => state.api
  );
  const user = sessionStorage.getItem("user");
  const userId = user ? JSON.parse(user)._id : null;

  const postId = postContent?._id;

  const currentPostActivities =
    recentActivity?.filter((activity) => {
      if (!activity || !postId) return false;
      const activityPostId = activity.postId?.$oid || activity.postId;
      const activityId = activityPostId?._id?.toString?.();
      const postIdStr = postId?.toString?.();
      return activityId === postIdStr;
    }) || [];

  useEffect(() => {
    if (postId) {
      dispatch(getActivityLog());
    }
  }, [postId]);

  const handleComment = async () => {
    if (!comment.trim() || !postId) return;

    try {
      const payload = {
        postId: postId,
        actionType: "commented",
        changes: [
          {
            field: "status",
            oldValue: postContent?.status || "draft",
            newValue: postContent?.status || "draft",
          },
        ],
        userID: userId,
        comment: comment.trim(),
      };

      const result = await dispatch(postActivity(payload)).unwrap();
      setComment("");
      dispatch(getActivityLog());
    } catch (error) {}
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setPostAction(false);
      }
      if (menuRef2.current && !menuRef2.current.contains(event.target)) {
        setReviewType(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function formatDate(isoString) {
    const date = new Date(isoString);
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  }
  const platformOptions = [
    {
      value: "facebook",
      label: "Facebook",
      icon: <FaFacebook />,
      color: "text-blue-600",
    },
    {
      value: "instagram",
      label: "Instagram",
      icon: <FaSquareInstagram />,
      color: "text-pink-700 text-3xl",
    },
  ];
  const handleApprove = (approveValue, type) => {
    const allowedFields = [
      "caption",
      "hashtags",
      "status",
      "approval",
      "publishedAt",
      "activityLogs",
    ];

    const updateData = {};

    allowedFields.forEach((key) => {
      const value = postContent?.[key];
      if (value !== undefined && value !== null) {
        updateData[key] = value;
      }
    });

    const approvalData = {
      isApproved: approveValue,
      approvedBy: userId,
      approvalDate: approveValue ? new Date() : null,
      rejectionReason: !approveValue ? rejectionReason : null,
    };

    updateData.approval_type = type;

    if (type === "re_schedule") {
      updateData.scheduleDate = new Date(selectedDateTime);
      updateData.isApproved = true;
    } else if (type === "post_now") {
      updateData.isApproved = true;
    }

    updateData.approval = approvalData;
    dispatch(
      editPost({
        id: postContent?._id,
        updateData,
        setApproved: true,
      })
    );
    close();
  };
  const approveAlert = async (type) => {
    const value = await showAlert({
      title: <span className="text-[18px]"></span>,
      text: "Are you sure you want to approve this request?",
      cancelButtonText: "Cancel",
      confirmButtonText: "Confirm",
    });
    if (value) {
      handleApprove(true, type);
    }
  };
  const rejectAlert = async () => {
    const value = await showAlert({
      title: <span className="text-[18px]"></span>,
      text: "Are you sure you want to reject this request?",
      cancelButtonText: "Cancel",
      confirmButtonText: "Confirm",
    });
    if (value) {
      handleApprove(false);
    }
  };
  const getType = (file) => {
    if (file instanceof Blob || file instanceof File) {
      return file.type.startsWith("image") ? "image" : "video";
    }

    if (typeof file === "string") {
      const lowerUrl = file.toLowerCase();
      if (
        lowerUrl.endsWith(".mp4") ||
        lowerUrl.endsWith(".webm") ||
        lowerUrl.endsWith(".mov")
      ) {
        return "video";
      }
      if (
        lowerUrl.endsWith(".png") ||
        lowerUrl.endsWith(".jpg") ||
        lowerUrl.endsWith(".jpeg") ||
        lowerUrl.endsWith(".gif") ||
        lowerUrl.endsWith(".webp")
      ) {
        return "image";
      }
    }

    return "image"; // default fallback
  };

  return (
    <div className="flex flex-col text-3 gap-4 pb-36  pt-3 ">
      {isEditPostLoading ? <Loader /> : <></>}
      <SocialDialog
        title={"Reject Post"}
        onClose={() => setRejectDialog(false)}
        isOpen={rejectDialog}
        content={
          <div className=" flex flex-col gap-2 w-full items-start max-h-[250px]">
            <label>Please Provide reason.</label>
            <textarea
              value={rejectionReason}
              onChange={(e) => {
                setRejectionReason(e.target.value);
              }}
              className="border-sm p-2 outline-none w-full border shadow-sm"
              rows={10}
            />
            <div className="flex w-full gap-2">
              <button
                onClick={() => rejectAlert(false)}
                className="px-2 py-2 text-xs flex gap-2 items-center hover:bg-blue-600 rounded transition-all duration-500 ease-in-out text-white bg-blue-500 relative"
              >
                Save
              </button>
              <button
                onClick={() => setRejectDialog(false)}
                className="px-2 py-2 text-xs flex gap-2 items-center hover:text-white hover:bg-gray-400 rounded transition-all duration-500 ease-in-out text-gray-700 bg-gray-200 relative"
              >
                Cancel
              </button>
            </div>
          </div>
        }
      />
      <div className="flex px-5 items-center justify-between ">
        <div className="flex justify-between w-full  items-center">
          <div className="flex items-center  space-x-2">
            <div
              className={`p-[2px] border-blue-600 border-[2px] rounded-full `}
            >
              <div
                className={`bg-white rounded-full ${
                  postContent?.type === "Facebook" ? "" : "p-[2px]"
                } `}
              >
                <div className="h-8 w-8 ">
                  <img
                    className="w-full h-full object-contain"
                    src={post_icon}
                  />
                </div>
              </div>
            </div>

            <div>
              <p className="text-sm font-semibold">
                {postContent?.accounts[0]?.accountName ||
                  "Showroom Text Name Is Here"}
              </p>
              <p className="text-[10px] text-gray-500">
                {postContent?.schedule?.isScheduled
                  ? formatDate(postContent?.schedule?.scheduledTime || "")
                  : ""}
              </p>
            </div>
          </div>
          <div className="flex items-center h-full gap-3">
            <div className="flex px-2">
              {platformOptions
                .filter((platform) =>
                  postContent?.platforms
                    ?.map((p) => p.platformName?.toLowerCase())
                    .includes(platform?.value?.toLowerCase())
                )
                .map((platform) => {
                  return (
                    <div
                      key={platform.value}
                      className={`cursor-pointer p-1.5 rounded-full transition flex items-center justify-center`}
                      title={platform.label}
                      style={{ width: 32, height: 32 }}
                    >
                      <div className={`text-[28px]  ${platform.color}`}>
                        {platform.icon}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="flex px-5 items-center justify-between ">
        <p>{postContent?.caption}</p>
      </div>
      <div className="w-[70%] mx-5 ">
        {postContent?.images && postContent.images.length > 0 && (
          <div className="mt-2">
            <Swiper
              modules={[Navigation]}
              navigation
              spaceBetween={10}
              slidesPerView={1}
              className="w-full  h-[250px]"
            >
              {postContent.images.map((media, index) => (
                <SwiperSlide key={index}>
                  {getType(media.url) === "image" ? (
                    <img
                      src={media.url}
                      alt={`media-${index}`}
                      className="w-auto shadow-2xl mx-auto h-full object-cover"
                    />
                  ) : getType(media.url) === "video" ? (
                    <video
                      src={media.url}
                      controls
                      className="w-auto shadow-2xl mx-auto h-full object-cover"
                    />
                  ) : null}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
      {showApproval && (
        <div className="border-t border-b border-gray-200 bg-gray-50">
          <div className="flex px-5 py-4 gap-4 items-center justify-between">
            {postContent?.status === "approved" ? (
              <div className="flex items-center gap-3 w-full justify-center">
                <p className="font-semibold text-green-600">
                  This post has been approved
                </p>
                <button
                  className="px-4 py-2 text-sm flex gap-2 items-center rounded bg-green-500 text-white cursor-default"
                  disabled
                >
                  Approved
                </button>
              </div>
            ) : postContent?.status === "rejected" ? (
              <div className="flex items-center gap-3 w-full justify-center">
                <p className="font-semibold text-red-600">
                  This post has been rejected
                </p>
                <button
                  className="px-4 py-2 text-sm flex gap-2 items-center rounded bg-red-500 text-white cursor-default"
                  disabled
                >
                  Rejected
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-10 w-full">
                <p className="font-semibold text-gray-700">
                  This post needs your approval to be published.
                </p>
                <div className="flex gap-3">
                  <button
                    // onClick={() => rejectAlert(false)}
                    onClick={() => setRejectDialog(true)}
                    className="px-4 py-2 text-sm flex gap-2 items-center hover:bg-red-600 rounded hover:-translate-y-1 transition-all duration-500 ease-in-out text-white bg-red-500"
                  >
                    <RxCrossCircled />
                    Reject
                  </button>
                  {viewApproveBtn && (
                    <button
                      ref={menuRef}
                      className="px-4 py-2 text-sm flex gap-2 items-center hover:bg-blue-600 rounded transition-all duration-500 ease-in-out text-white bg-blue-500 relative"
                      onClick={() => {
                        setPostAction((prev) => !prev);
                      }}
                    >
                      <span>Approve</span>
                      <span>
                        {postAction ? (
                          <RxCaretUp className="text-xl" />
                        ) : (
                          <RxCaretDown className="text-xl" />
                        )}
                      </span>
                      {postAction && (
                        <div className="absolute right-0 mt-2 top-full text-sm bg-white rounded-lg shadow-xl border border-gray-200 w-[210px] overflow-hidden z-50">
                          <button
                            onClick={() => approveAlert("post_now")}
                            className="flex px-3  py-1 hover:bg-[#e6f7ff] hover:font-bold text-[#007aff]  gap-3 w-full items-center"
                          >
                            Approve and Post Now
                          </button>
                          <button
                            onClick={() => {
                              setSchedule(true);
                              setViewApproveBtn(false);
                            }}
                            className="flex px-3  py-1 hover:bg-[#e6f7ff] hover:font-bold text-[#007aff]  gap-3 w-full items-center"
                          >
                            Approve and Schedule
                          </button>
                        </div>
                      )}
                    </button>
                  )}
                </div>
                {schedule && (
                  <div className="flex items-center gap-2">
                    <DatePicker
                      value={selectedDateTime}
                      onChange={setSelectedDateTime}
                      format="YYYY/MM/DD HH:mm:ss"
                      plugins={[<TimePicker position="bottom" />]}
                      className="blue"
                      style={{
                        padding: "18px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        fontSize: "14px",
                      }}
                    />
                    <button
                      onClick={() => approveAlert("re_schedule")}
                      className=" text-white text-lg rounded bg-blue-500 p-2"
                    >
                      <FaCheck />
                    </button>
                    <button
                      onClick={() => {
                        setSelectedDateTime(new Date());
                        setSchedule(false);
                        setViewApproveBtn(true);
                      }}
                      className=" text-white text-lg rounded bg-blue-500 p-2"
                    >
                      <ImCross />
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      <div className="border-t-[1.5px] mx-5 mt-6"></div>
      <div className="flex flex-col gap-5 px-5">
        <p className="text-base font-semibold">Post Activity</p>

        {currentPostActivities?.length > 0 ? (
          currentPostActivities.map((activity, index) => (
            <div key={activity._id || index} className="flex items-start gap-3">
              <div
                className={`p-[2px] rounded-full shrink-0 ${
                  activity?.platform === "Facebook"
                    ? "border-blue-300 border-[2px]"
                    : "border-transparent border-[1px] bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045]"
                }`}
              >
                <div className="w-10 h-10 rounded-full overflow-hidden bg-white">
                  <img
                    src={activity?.file}
                    alt="user"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="flex flex-col">
                {activity?.comments?.length > 0 ? (
                  activity.comments.map((comment, commentIndex) => (
                    <div key={commentIndex} className="mb-3">
                      <p className="text-sm font-semibold text-gray-800">
                        {comment?.commented_by?.user_name || "Unknown User"}
                      </p>
                      <p className="text-sm text-gray-700">{comment?.text}</p>
                      <p className="text-xs text-gray-400 mt-1">
                        {formatDate(comment?.timestamp || activity?.actionDate)}
                      </p>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-sm text-gray-700">
                      {activity?.actionType === "approved"
                        ? "Approved the post"
                        : activity?.actionType === "rejected"
                        ? "Rejected the post"
                        : activity?.actionType === "edited"
                        ? "Edited the post"
                        : "No comment provided for this activity."}
                    </p>
                    <p className="text-xs text-gray-400 mt-1">
                      {formatDate(activity?.timestamp || activity?.actionDate)}
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500">
            No activity found for this post
          </p>
        )}
      </div>
      <div className="fixed left-0  py-2 px-3 bottom-0 right-0 bg-white border-t-2  w-full">
        <div className="flex gap-2 items-center">
          <div
            className={`p-[2px]  ${
              postContent?.type === "Facebook"
                ? " border-[2px]"
                : "border-transparent border-[1px] "
            } rounded-full `}
          >
            <div
              className={`bg-white shadow-md rounded-full w-10 h-10 overflow-hidden ${
                postContent?.type === "Facebook" ? "" : "p-[2px]"
              }`}
            >
              <img
                src={userImage}
                alt="preview"
                className="w-full h-full rounded-full object-cover"
              />
            </div>
          </div>
          <input
            placeholder="Type here..."
            className="w-[30vw] outline-none text-lg px-4"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleComment()}
          />

          <div className="flex items-center">
            <button className="hover:-translate-y-1 text-gray-400 hover:text-black ease-in-out p-2 transition-all text-lg hover:text-2xl duration-700">
              <FaRegFaceSmile />
            </button>
            <button className="hover:-translate-y-1 text-gray-400 hover:text-black ease-in-out text-2xl hover:text-3xl p-2 transition-all duration-700">
              <IoIosAt />
            </button>
            <button
              onClick={handleComment}
              disabled={!comment.trim()}
              className={`hover:-translate-y-1 ${
                comment.trim()
                  ? "text-blue-600 hover:text-blue-700"
                  : "text-gray-400"
              } ease-in-out p-2 text-xl hover:text-2xl transition-all duration-700 disabled:cursor-not-allowed`}
            >
              <RxPaperPlane />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostPreview;
